module.exports = __webpack_public_path__ + "static/media/clock.b74e007b.svg";